import { render } from "./CollapseInnerCard.vue?vue&type=template&id=571df0d1"
import script from "./CollapseInnerCard.vue?vue&type=script&lang=js"
export * from "./CollapseInnerCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CollapseInnerCard.vue?vue&type=style&index=0&id=571df0d1&lang=less&module=true"
cssModules["$style"] = style0

import exportComponent from "/var/jenkins_home/workspace/00-client-web(prod)/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__